import { render, staticRenderFns } from "./BasicFacts.vue?vue&type=template&id=10713bfe&scoped=true&"
import script from "./BasicFacts.vue?vue&type=script&lang=js&"
export * from "./BasicFacts.vue?vue&type=script&lang=js&"
import style0 from "./BasicFacts.vue?vue&type=style&index=0&id=10713bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10713bfe",
  null
  
)

export default component.exports